import { z } from 'zod';
import { CursorPagination } from './common.js';
export const AuditEntry = z.object({
    id: z.string().uuid(),
    ts: z.string().datetime(),
    actor: z.string(), // sales user id or 'system'
    action: z.string(),
    resourceType: z.string(),
    resourceId: z.string(),
    beforeJson: z.record(z.unknown()).nullable(),
    afterJson: z.record(z.unknown()).nullable(),
    requestId: z.string().nullable(),
});
export const ListAuditQuery = CursorPagination.extend({
    actor: z.string().optional(),
    action: z.string().optional(),
    resourceType: z.string().optional(),
    resourceId: z.string().optional(),
    since: z.string().datetime().optional(),
    until: z.string().datetime().optional(),
});
//# sourceMappingURL=audit.js.map